module.exports = __webpack_public_path__ + "img/top-question-mark.94def354.png";